import axios from 'axios';

// Base configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add auth token and store_id
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Thêm store_id vào request
    const storeId = localStorage.getItem('store_id');
    if (storeId) {
      const method = config.method.toLowerCase();
      
      // POST, PUT, PATCH: thêm vào body
      if (method === 'post' || method === 'put' || method === 'patch') {
        if (config.data) {
          // Nếu data là FormData, append vào FormData
          if (config.data instanceof FormData) {
            config.data.append('store_id', storeId);
          } else {
            // Nếu là object, thêm property
            config.data = {
              ...config.data,
              store_id: storeId
            };
          }
        } else {
          config.data = { store_id: storeId };
        }
      } 
      // GET, DELETE: thêm vào params
      else {
        if (!config.params) {
          config.params = {};
        }
        config.params.store_id = storeId;
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle common errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('authToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient; 